import { ActionType, createAction, createAsyncAction } from "typesafe-actions";

import { Route } from "@mapmycustomers/shared/types/entity";
import { ListRequest } from "@mapmycustomers/shared/types/viewModel/internalModel/ListRequest";
import ViewState from "@mapmycustomers/shared/types/viewModel/ViewState";

import { ListFetcherPayload } from "@app/types/viewModel/ListFetcher";

export const initializeListView = createAsyncAction(
  "route/listView/initialize/request",
  "route/listView/initialize/success",
  "route/listView/initialize/failure"
)<void, ViewState, unknown>();

export const applyListViewSettings = createAction("route/listView/applySettings")<
  Partial<ListRequest>
>();

export const fetchRoutesList = createAsyncAction(
  "route/listView/fetch/request",
  "route/listView/fetch/success",
  "route/listView/fetch/failure"
)<ListFetcherPayload<Route>, { totalFilteredRecords: number; totalRecords: number }, unknown>();

export type Actions = ActionType<
  typeof applyListViewSettings | typeof fetchRoutesList | typeof initializeListView
>;
